import React from 'react';

import { Context } from 'js/components/LocaleWrapper';
import { ErrorPage } from './CommonErrorPage';

export function Error500Page(): React.ReactElement {
  const { i18n } = React.useContext(Context);
  return <ErrorPage message={i18n('page.error.500.description')} />;
}
